import ScorecardAttributesModel from './scorecard-attributes-model'
import AncestorStep from '../common/ancestor-step'

const ScorecardAttributesPath = {
	icon: 'scorecard',
	key: 'report.scorecardAttributes.title',
	steps: [AncestorStep],
	model: ScorecardAttributesModel
}

export default ScorecardAttributesPath

ScorecardAttributesPath.__filename__ = 'reports/wizard/scorecard-attributes/scorecard-attributes-path.js'
